export const config = {
  apiUrl: 'http://localhost:8080/api',
  authRoles: {
    ROLE_ROOT: ['ROLE_ROOT'], // Only Super ROLE_ADMIN has access
    ROLE_ADMIN: ['ROLE_ROOT', 'ROLE_ADMIN'], // Only SA & ROLE_ADMIN has access
    editor: ['ROLE_ROOT', 'ROLE_ADMIN', 'Editor'], // Only SA & ROLE_ADMIN & Editor has access
    user: ['ROLE_ROOT', 'ROLE_ADMIN', 'Editor', 'User'], // Only SA & ROLE_ADMIN & Editor & User has access
    guest: ['ROLE_ROOT', 'ROLE_ADMIN', 'Editor', 'User', 'Guest'] // Everyone has access
  }
}
